import React, { Component } from "react";
import { Link } from "react-router-dom";
// styles for page
import "./authentication.css";
// images for page
import Logo from "../assets/images/logo.png";
import LeftPartBg from "../assets/images/forgot_password/image.png";
import Loader from "../assets/images/loader.svg";
// import request module
import axios from "axios";
// import icons
import Ionicon from "react-ionicons";

export default class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailValid: null,
      pageToRend: "resetPage",
      emailTypeLoader: false,
      authError: false
    };

    this.buttonActive = null;
    this.emailAlertClass = null;
    this.iconSize = "45px";
    //  on type timer
    this.timer = null;
    this.typeDelay = 700;
  }
  componentDidMount = () => {
    this.refs.email.focus();
    this.buttonActive = false;
  };
  handleChange = e => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState(
      {
        [name]: value,
        authError: false,
        // values for validate
        fieldToValidateName: name,
        fieldToValidateValue: value
      },
      this.timerLoader(name)
    );
  };
  // delay on field type,show/hide loader
  timerLoader = n => {
    // reset timer
    window.clearTimeout(this.timer);
    // turn on loader ,turn off validation

    this.setState({
      [n + "TypeLoader"]: true,
      [n + "Valid"]: null
    });
    // turn off loader
    setTimeout(() => {
      this.setState({ [n + "TypeLoader"]: false });
    }, 400);
    // // after delay, callback validation function
    this.timer = setTimeout(() => {
      this.checkValidation();
    }, this.typeDelay);
  };
  handleSubmit = event => {
    event.preventDefault();
  };
  checkValidation = () => {
    let argName = this.state.fieldToValidateName;
    let argValue = this.state.fieldToValidateValue;
    // check email validation
    if (argName === "email") {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(argValue)) {
        this.setState({
          emailValid: false
        });
      } else {
        this.setState({
          emailValid: true
        });
      }
    }
  };
  render() {
    // email validation alert
    const emailValidHTML = this.state.emailValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">Enter valid email adress</span>
      </React.Fragment>
    );
    // button state
    if (this.state.emailValid) {
      this.buttonActive = true;
    } else {
      this.buttonActive = false;
    }
    // check email alerts
    if (this.state.emailValid !== null) {
      this.state.emailValid
        ? (this.emailAlertClass = "succes")
        : (this.emailAlertClass = "warrning");
    }

    const resetPage = (
      <div className="Form">
        <form onSubmit={this.handleSubmit}>
          <img src={Logo} />
          <div className="formHeading">Reset Password</div>
          <label className="centered grayTxt">
            <Link to="/login" className="btnLink">
              {"<   Back to login"}
            </Link>
          </label>
          <label className="labelRelative">
            <input
              type="email"
              placeholder="Email"
              name="email"
              onChange={this.handleChange}
              value={this.state.email}
              className={this.emailAlertClass}
              ref="email"
            />
            {this.state.emailValid !== null ? emailValidHTML : null}
            {this.state.emailTypeLoader ? (
              <span className="typeLoader">
                <img src={Loader} />
              </span>
            ) : null}
            {this.state.authError ? (
              <span className="alertText">
                Your email address is not registered.
              </span>
            ) : null}
          </label>

          <button
            className="buttonMid"
            type="submit"
            disabled={!this.buttonActive}
          >
            <span>RECOVER PASSWORD</span>
          </button>
        </form>
      </div>
    );
    const resentEmailPage = (
      <div className="Form">
        <form onSubmit={this.handleSubmit}>
          <img src={Logo} />
          <div className="formHeading">Reset Email Sent</div>
          <label className="centered grayTxt">
            <Link to="/login" className="btnLink">
              {"< Back to login"}
            </Link>
          </label>
          <label className="labelDesc">
            Password reset link has been sent to the email address associated
            with your account
          </label>
          <button className="buttonMid" type="submit">
            <span>RESENT THE EMAIL</span>
          </button>
        </form>
      </div>
    );
    let form;
    if (this.state.pageToRend == "resetPage") {
      form = resetPage;
    }
    if (this.state.pageToRend == "resentEmailPage") {
      form = resentEmailPage;
    }
    return (
      <React.Fragment>
        <div className="authPage">
          <div className="leftPart grayBg">
            <img src={LeftPartBg} />
          </div>
          <div className="rightPart">{form}</div>
        </div>
      </React.Fragment>
    );
  }
}
